import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { useSeo } from "../components/common";
import { PageHero } from "../components/PageHero";
import { CONTACT, IMG } from "../data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    intro: "Sparko respects your privacy and is committed to protecting your personal data in accordance with the GDPR (AVG).",
    sections: [
      ["Data We Collect", "We collect information you provide when requesting a quote or contacting us: name, company, phone, email, address, and any details or photos you share about your cleaning needs."],
      ["How We Use Your Data", "Your data is used solely to respond to your request, provide a quote, deliver our services, and communicate with you. We never sell your data to third parties."],
      ["Cookies", "We use minimal cookies to remember your language preference and improve your browsing experience. You may accept or decline non-essential cookies via our banner."],
      ["Your Rights", "Under the GDPR you have the right to access, correct or delete your personal data at any time. Contact us to exercise these rights."],
      ["Data Retention", "We retain submission data only as long as necessary to provide our services and meet legal obligations."],
      ["Contact", `For any privacy questions, email us at ${CONTACT.email} or call ${CONTACT.phone}. KVK: ${CONTACT.kvk}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    intro: "These terms govern the use of the Sparko website and the cleaning services we provide across the Netherlands.",
    sections: [
      ["Services", "Sparko provides professional cleaning and maintenance services. The scope of each engagement is agreed in a tailored quote before work commences."],
      ["Quotes & Pricing", "Quotes are free and valid for 30 days. Final pricing is confirmed after a free site inspection where applicable."],
      ["Bookings & Cancellations", "Bookings can be scheduled as one-time or recurring. Please provide at least 24 hours notice for cancellations."],
      ["Satisfaction Guarantee", "If you are not satisfied with any service, notify us within 24 hours and we will re-clean the affected area at no additional cost."],
      ["Liability", "Sparko is fully insured. Our liability is limited to the value of the services provided, in line with Dutch law."],
      ["Contact", `For questions about these terms, email ${CONTACT.email} or call ${CONTACT.phone}. KVK: ${CONTACT.kvk}.`],
    ],
  },
};

export default function Legal({ type }) {
  const c = CONTENT[type];
  useSeo(`${c.title} | Sparko`, c.intro);
  return (
    <div>
      <PageHero title={c.title} crumb={c.title} bg={IMG.office3} />
      <section className="mx-auto max-w-3xl px-5 md:px-8 py-20">
        <p className="text-lg text-navy font-display leading-snug">{c.intro}</p>
        <div className="mt-10 space-y-8">
          {c.sections.map(([h, body], i) => (
            <div key={i}>
              <h2 className="font-display text-2xl text-navy">{i + 1}. {h}</h2>
              <p className="mt-3 text-slate-600 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
        <p className="mt-12 text-sm text-slate-400">Last updated: {new Date().getFullYear()}</p>
      </section>
    </div>
  );
}
